import BigClient from './BigClient.vue';

export default BigClient;
